package com.cybersoftsolution.cybersoftsolutionweb.components.htmlEditor

import com.cybersoftsolution.cybersoftsolutionweb.utils.IdConst
import com.cybersoftsolution.cybersoftsolutionweb.utils.IdConst.editorIdPreview
import kotlinx.browser.document
import org.w3c.dom.HTMLTextAreaElement

fun getEditor(id:String) = document.getElementById(id) as HTMLTextAreaElement

fun HTMLTextAreaElement.getSelectedText():String?{
    val range = this.getSelectedIntRange()
    return if (range != null ) {
        this.value.substring(range = range)
    } else null
}

fun HTMLTextAreaElement.getSelectedIntRange():IntRange?{
    val start = this.selectionStart
    val end = this.selectionEnd?.minus(1)
    return if (start != null && end != null) {
        IntRange(start, end)
    } else null
}

fun applyControlStyle(editorId:String = IdConst.editorId, controlStyle: ControlStyle){
    val editor = getEditor(editorId)

    with (editor) {
        val selectedText = getSelectedText()
        val selectedIntRange = getSelectedIntRange()

        if (!selectedText.isNullOrEmpty() && selectedIntRange != null) {
            value = value.replaceRange(
                range = selectedIntRange,
                replacement = controlStyle.style
            )
            document.getElementById(editorId+ editorIdPreview)?.innerHTML = value
        }

    }

}

fun removeControlStyle(editorId:String = IdConst.editorId, controlStyle: ControlStyle){
    val editor = getEditor(editorId)

    with (editor) {
        val selectedText = getSelectedText()
        val selectedIntRange = getSelectedIntRange()

        if (!selectedText.isNullOrEmpty() && selectedIntRange != null) {
            value = value.replace(controlStyle.style,selectedText,true)
            document.getElementById(editorId+ editorIdPreview)?.innerHTML = value
        }

    }

}

fun verifyControlStyle(editorId:String = IdConst.editorId, controlStyle: ControlStyle){
    val editor = getEditor(editorId)

    with (editor) {
        val selectedText = getSelectedText()
        val comparableString = controlStyle.style

        if (!selectedText.isNullOrEmpty() && value.contains(comparableString,true)) {
            removeControlStyle(editorId = editorId, controlStyle = controlStyle)
        } else {
            applyControlStyle(editorId = editorId, controlStyle = controlStyle)
//            applyControlStyle(editorId = editorId, controlStyle = ControlStyle.Bold(selectedText = getEditor(id = editorId).getSelectedText()))
        }

    }

}

fun String.extractTikTokIdFromLinkOrEmbed(): String {
    val regex = """(?:https://www.tiktok.com/@\w+/video/|data-video-id=")([^?"#]+)""".toRegex()
    val matchResult = regex.find(this)
    return matchResult?.groups?.get(1)?.value ?: "Set_Video_ID"
}

//fun String?.extractTikTokIdFromRegularLink(): String {
//    val regex = "video/([^?]+)".toRegex()
//    val matchResult = regex.find(this?:"")
//    return matchResult?.groups?.get(1)?.value?:"Set_Video_ID"
//}
//fun String?.extractTikTokIdFromEmbed(): String {
//    val regex = "data-video-id=\"([^\"]+)\"".toRegex()
//    val matchResult = regex.find(this?:"")
//    return matchResult?.groups?.get(1)?.value?:"Set_Video_ID"
//}


//fun String.extractTikTokId(): String {
//    // Regex para enlaces regulares (simplificado)
//    val regularLinkRegex = """https://www.tiktok.com/@\w+/video/\d+""".toRegex()
//
//    // Regex para enlaces embed (busca el atributo data-video-id)
//    val embedLinkRegex = """data-video-id="(\d+)""".toRegex()
//
//    return when {
//        regularLinkRegex.matches(this) -> this.extractTikTokIdFromRegularLink()
//        embedLinkRegex.find(this) != null -> this.extractTikTokIdFromEmbed()
//        else -> "Set_Video_ID"
//    }
//
//}